import { Injectable } from '@angular/core';
import { webSocket, WebSocketSubject } from 'rxjs/webSocket';
import sessionStorageUtility from '../common/utils/sessionStorage';
import { HttpService } from './http.service';
import { WebSocketTokenApiPayload } from '../common/response/response';

@Injectable({
    providedIn: 'root',
})
export class WebsocketService {
    private socket$: WebSocketSubject<any> | null = null;

    constructor(private httpService: HttpService) {}

    getWebSocketToken(url: string, resolving: string): Promise<string> {
        return new Promise((resolve, reject) => {
            const userView = sessionStorageUtility.getLoginUserDetails();
            const payload: WebSocketTokenApiPayload = {
                user_id: userView.user_id,
                tenant_id: userView.tenant_id,
                login_token: sessionStorageUtility.getAccessToken(),
            };
            this.httpService
                .post(url, payload, true)
                .then((response: any) => {
                    if (response) {
                        resolve(response[resolving]);
                    }
                })
                .catch(() => {
                    reject('');
                });
        });
    }

    connect(url: string, token: string, type: string = 'json'): void {
        if (this.socket$) {
            this.closeConnection();
        }

        const options = {
            url: `${url}?token=${token}`,
            serializer: (value: any) => JSON.stringify(value), // No transformation for outgoing messages
            deserializer: (event: any) => JSON.parse(event.data), // No transformation for incoming messages
        };

        if (type === 'plain-text') {
            options.deserializer = (event: any) => event.data; // No transformation for incoming messages
            options.serializer = (value: any) => value; // No transformation for outgoing messages
        }

        this.socket$ = webSocket(options);
    }

    sendMessage(message: any): void {
        if (this.socket$) {
            this.socket$.next(message);
        } else {
            console.error('WebSocket is not connected.');
        }
    }

    getMessages() {
        if (this.socket$) {
            return this.socket$.asObservable();
        } else {
            throw new Error('WebSocket is not connected. Call connect() first.');
        }
    }

    closeConnection(): void {
        if (this.socket$) {
            this.socket$.complete();
            this.socket$ = null;
            console.log('WebSocket connection closed.');
        }
    }
}
